import { createAsyncThunk } from '@reduxjs/toolkit';

import { ICreatePunchRequestDTO, IPunchDTO } from 'src/api/dtos';
import PunchRepository from 'src/api/repositories/ess/v1/punch.repository';

import { resetPunchActionCreator } from './punches.slice';
import { PunchDispatch } from './punches.types';

export const fetchRecentPunches = createAsyncThunk<IPunchDTO[], void>(
  'punches/recent',
  async (_, { rejectWithValue }) => {
    try {
      const repository = new PunchRepository();
      return await repository.getRecentPunches();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const createPunch = createAsyncThunk<IPunchDTO, ICreatePunchRequestDTO>(
  'punches/create',
  async (payload: ICreatePunchRequestDTO, { rejectWithValue }) => {
    try {
      const repository = new PunchRepository();
      const response = await repository.create(payload);

      return { ...response.punchInformation };
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

export const reset = () => {
  return (dispatch: PunchDispatch): void => {
    dispatch(resetPunchActionCreator());
  };
};
